// extracted by mini-css-extract-plugin
var _1 = "styles-module__cautionAlert--EOAV9";
var _2 = "styles-module__header--bW5JP";
var _3 = "styles-module__infoButton--Z8Nth";
var _4 = "styles-module__tooltip--oI00l";
export { _1 as "cautionAlert", _2 as "header", _3 as "infoButton", _4 as "tooltip" }
